import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		label: {
			marginBottom: 0,
		},
	} satisfies Record<string, CSSObject>);
